import { StateCreator } from 'zustand';

import { RemoveFunctions } from '../../utils/types';

export type TableGroupExpansionsValue = {
  expanded: boolean;
  groupLevel: number;
};

type TableGroupExpansionsByGroup = {
  [groupId: string]: TableGroupExpansionsValue;
};

export type TableGroupExpansionsSlice = {
  tableGroupExpansions: Partial<{
    [pageFilterInstanceId: string]: Partial<{
      [widgetFilterInstanceId: string]: TableGroupExpansionsByGroup;
    }>;
  }>;

  setTableGroupExpansion(
    pageFilterInstanceId: string,
    widgetFilterInstanceId: string,
    groupId: string,
    value: TableGroupExpansionsValue
  ): void;
  cloneTableGroupExpansions(
    pageFilterInstanceIdFrom: string,
    widgetFilterInstanceIdFrom: string,
    pageFilterInstanceIdTo: string,
    widgetFilterInstanceIdTo: string
  ): void;
  deleteTableGroupExpansions(
    pageFilterInstanceId: string,
    widgetFilterInstanceId: string
  ): void;
  resetTableGroupExpansionsSlice(): void;
};

const initialState: RemoveFunctions<TableGroupExpansionsSlice> = {
  tableGroupExpansions: {},
};

export const createTableGroupExpansionSlice: StateCreator<
  TableGroupExpansionsSlice,
  [],
  [],
  TableGroupExpansionsSlice
> = (set) => ({
  ...initialState,
  setTableGroupExpansion(
    pageFilterInstanceId,
    widgetFilterInstanceId,
    groupId,
    value
  ) {
    set((state) => {
      return {
        tableGroupExpansions: {
          ...state.tableGroupExpansions,
          [pageFilterInstanceId]: {
            ...state.tableGroupExpansions[pageFilterInstanceId],
            [widgetFilterInstanceId]: {
              ...state.tableGroupExpansions[pageFilterInstanceId]?.[
                widgetFilterInstanceId
              ],
              [groupId]: value,
            },
          },
        },
      };
    });
  },

  cloneTableGroupExpansions(
    pageFilterInstanceIdFrom,
    widgetFilterInstanceIdFrom,
    pageFilterInstanceIdTo,
    widgetFilterInstanceIdTo
  ) {
    set((state) => {
      const expansions =
        state.tableGroupExpansions[pageFilterInstanceIdFrom]?.[
          widgetFilterInstanceIdFrom
        ];
      if (expansions == null) {
        return state;
      }

      return {
        tableGroupExpansions: {
          ...state.tableGroupExpansions,
          [pageFilterInstanceIdTo]: {
            ...state.tableGroupExpansions[pageFilterInstanceIdTo],
            [widgetFilterInstanceIdTo]: { ...expansions },
          },
        },
      };
    });
  },

  deleteTableGroupExpansions(pageFilterInstanceId, widgetFilterInstanceId) {
    set((state) => {
      const pageExpansions = state.tableGroupExpansions[pageFilterInstanceId];
      if (pageExpansions?.[widgetFilterInstanceId] == null) {
        return state;
      }

      const { [widgetFilterInstanceId]: _, ...remainingWidgetExpansions } =
        pageExpansions;

      return {
        tableGroupExpansions: {
          ...state.tableGroupExpansions,
          [pageFilterInstanceId]: remainingWidgetExpansions,
        },
      };
    });
  },

  resetTableGroupExpansionsSlice() {
    set({ ...initialState });
  },
});
